import React from 'react';
import { Select } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { Button, Divider, SelectProps } from 'components';
import { BaseOptionType, DefaultOptionType } from 'antd/lib/select';
import { useItemSelectorListMultipleQuery } from 'api';

export interface FMGSelectProps extends SelectProps<any, BaseOptionType | DefaultOptionType> {
  brandIds?: string[];
  showAdd?: boolean;
  onAdd?: () => void;
  requireBrandId?: boolean;
}

export const ItemSkuSelect = React.memo(
  React.forwardRef<any, FMGSelectProps>((props: FMGSelectProps, ref) => {
    const { showAdd = false, onAdd, dropdownRender, brandIds, requireBrandId = false, ...selectProps } = props;
    const skipQuery = requireBrandId && !brandIds;
    const queryArgs = brandIds ? { brandIds } : undefined;
    const { data = [] } = useItemSelectorListMultipleQuery(queryArgs, { skip: skipQuery });
    const defaultDropdownRender = (menu: React.ReactElement) => (
      <>
        {menu}
        {showAdd && (
          <>
            <Divider />
            <div style={{ display: 'flex', justifyContent: 'center', padding: 8 }}>
              <Button type="link" style={{ color: '#05796B', margin: 0 }} icon={<PlusOutlined />} onClick={onAdd}>
                Add New
              </Button>
            </div>
          </>
        )}
        {dropdownRender && dropdownRender(menu)}
      </>
    );
    return (
      <Select
        ref={ref}
        options={data}
        showSearch
        dropdownRender={defaultDropdownRender}
        filterOption={(input, option) => option?.label?.toString().toLowerCase().includes(input.toLowerCase()) ?? false}
        {...selectProps}
      />
    );
  })
);
